'use strict'

/* -----------------------------------------------------------------------------
 * dashboard filter options
 * -------------------------------------------------------------------------- */

/**
 * Home dashboards build their PHARMD/EMPLOYER dropdowns from the rows they
 * already received, instead of a separate user/company lookup. Rows whose id
 * is missing are skipped, so a filter stays hidden until the endpoint returns
 * the id its query parameter needs.
 */

export type DashboardFilterOption = {
  id: number
  name: string
}

export const toFilterOptions = <Item>(
  items: Item[],
  getId: (item: Item) => number | undefined | null,
  getName: (item: Item) => string | undefined | null
): DashboardFilterOption[] => {
  const byId = new Map<number, DashboardFilterOption>()

  items.forEach(item => {
    const id = getId(item)
    const name = getName(item)
    if (id == null || !name || byId.has(id)) {
      return
    }
    byId.set(id, { id, name })
  })

  return [...byId.values()].sort((a, b) => a.name.localeCompare(b.name))
}
